import React, { useState, useEffect } from "react";
import EmployeeNumberConfigSection from "./EmployeeNumberConfigSection";
import TagEditorPage from "./TagEditorPage";
import DropdownManager from "./DropdownManager";
import InterviewManager from "./InterviewManager";
import TrainingQuiz from "./TrainingQuiz";
import CustomTaskCreateHelper from "./CustomTaskCreateHelper";
import ReferenceCheckAdminPage from "./ReferenceCheckAdminPage";
import NotificationAlertsPage from "./NotificationAlertsPage";
import useAccess from "../../hooks/useAccess";
import "../../styles/AccountSettingsPage.css"; // Scoped CSS for this page only

const TABS = [
  { key: "profile", label: "Profile", resource: "Profile" },
  { key: "tags", label: "Tags", resource: "Tags" },
  {
    key: "dropdownManager",
    label: "Dropdown Manager",
    resource: "Dropdown Manager",
  },
  {
    key: "interviewQuestion",
    label: "Interview Question",
    resource: "Interview Question",
  },
  { key: "trainingQuiz", label: "Training Quiz", resource: "Training Quiz" },
  {
    key: "customTaskCreateHelper",
    label: "Custom Task Create Helper",
    resource: "Custom Task Create Helper",
  },
  {
    key: "referenceCheck",
    label: "Reference Check",
    resource: "Reference Check",
  },
  {
    key: "notificationsAlerts",
    label: "Notifications / Alerts",
    resource: "Notifications / Alerts",
  },
];

const AccountSettingsPage = () => {
  const { hasPermission } = useAccess();
  const [tab, setTab] = useState(
    () => localStorage.getItem("accountSettingsTab") || "profile"
  );

  // ✅ Add a body class only while this page is mounted
  useEffect(() => {
    document.body.classList.add("account-settings-mode");
    return () => {
      document.body.classList.remove("account-settings-mode");
    };
  }, []);

  const visibleTabs = TABS.filter((tabItem) =>
    hasPermission("AccountSetting", tabItem.resource, "view"),
  );

  useEffect(() => {
    if (!visibleTabs.some((tabItem) => tabItem.key === tab)) {
      const fallbackTab = visibleTabs[0]?.key || "profile";
      setTab(fallbackTab);
      localStorage.setItem("accountSettingsTab", fallbackTab);
    }
  }, [tab, visibleTabs]);

  return (
    <div className="account-settings-container">
      {/* Left Sidebar (page-local) */}
      <div className="admin-sidebar">
        <div className="admin-sidebar-title">Administration</div>
        <ul>
          {visibleTabs.map((t) => (
            <li key={t.key}>
              <button
                onClick={() => {
                  setTab(t.key);
                  localStorage.setItem("accountSettingsTab", t.key);
                }}
                className={`admin-sidebar-tab${tab === t.key ? " admin-sidebar-tab--active" : ""}`}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Right Content */}
      <div className="account-settings-content">
        {tab === "profile" && (
          <>
            <EmployeeNumberConfigSection />
          </>
        )}
        {tab === "tags" && <TagEditorPage hideAssignTab={true} />}
        {tab === "dropdownManager" && <DropdownManager />}
        {tab === "interviewQuestion" && <InterviewManager />}
        {tab === "trainingQuiz" && <TrainingQuiz />}
        {tab === "customTaskCreateHelper" && <CustomTaskCreateHelper />}
        {tab === "referenceCheck" && <ReferenceCheckAdminPage />}
        {tab === "notificationsAlerts" && <NotificationAlertsPage />}
      </div>
    </div>
  );
};

export default AccountSettingsPage;
